import React, { FC, useEffect, useState } from 'react';

import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { useSearchContext } from '@src/main/ui/providers/search/SearchContextProvider';

import Icon from '@src/main/ui/components/common/Icon/Icon';
import styles from './SearchBar.module.scss';

interface Props {
  placeholder: string;
}

const SearchBar: FC<Props> = ({ placeholder }) => {
  const { searchInputLocal, setSearchInput, setSearchInputLocal } = useSearchContext();
  const [timeoutId, setTimeoutId] = useState<ReturnType<typeof setTimeout> | null>(null);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSearchInputLocal(event.target.value);
    if (timeoutId) clearTimeout(timeoutId);
    const newTimeoutId = setTimeout(() => {
      setSearchInput(value);
    }, 400);
    setTimeoutId(newTimeoutId);
  };

  useEffect(() => {
    if (!searchInputLocal) {
      setSearchInput('');
    }
  }, [searchInputLocal, setSearchInput]);

  return (
    <div className={styles.searchBar}>
      <TextField
        value={searchInputLocal}
        fullWidth
        onChange={onChange}
        placeholder={placeholder}
        variant="standard"
        autoFocus
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon iconId="search" />
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
};

export default SearchBar;
